/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section7_TitleInputs */

const en_terms_section7_title = /** @type {(inputs: Terms_Section7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const ko_terms_section7_title = /** @type {(inputs: Terms_Section7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문의`)
};

const ja_terms_section7_title = /** @type {(inputs: Terms_Section7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お問い合わせ`)
};

/**
* | output |
* | --- |
* | "Contact" |
*
* @param {Terms_Section7_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const terms_section7_title = /** @type {((inputs?: Terms_Section7_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section7_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_section7_title(inputs)
	if (locale === "ko") return ko_terms_section7_title(inputs)
	return ja_terms_section7_title(inputs)
});